/**
 * Monthly credits: the sidebar meter, the chat block message and the admin
 * user editor. 1 credit = 1,000 tokens (Credits:TokensPerCredit on the server).
 */
const en = {
  // Chat error (HTTP 429 code CREDITS_EXHAUSTED)
  'chat.err.CREDITS_EXHAUSTED': "You've used all your credits for this month. They reset at the start of next month, or ask an administrator for more.",

  // Sidebar meter
  'credits.label': 'Credits',
  'credits.left': '{left} of {total} left',
  'credits.unlimited': 'Unlimited credits',
  'credits.meterLabel': 'Credits used this month: {used} of {total}',
  'credits.warning': "You've used {pct}% of this month's credits.",
  'credits.exhausted': 'Out of credits until {date}.',
  'credits.resets': 'Resets {date}',

  // Admin: users table
  'credits.admin.col': 'Credits',
  'credits.admin.cellUsed': '{used} / {total}',
  'credits.admin.cellUnlimited': 'Unlimited',

  // Admin: user editor
  'credits.admin.section': 'Monthly credits',
  'credits.admin.usage': 'This month: {used} of {total} credits used ({pct}%). Resets {date}.',
  'credits.admin.usageUnlimited': 'This month: {used} credits used. Never blocked.',
  'credits.admin.unlimited': 'Unlimited credits',
  'credits.admin.adminNote': 'Admins are never blocked for credits.',
  'credits.admin.monthly': 'Monthly allowance (credits)',
  'credits.admin.monthlyDefault': 'Default: {n}',
  'credits.admin.monthlyHint': '1 credit = 1,000 tokens across all agents and tasks. Leave empty for the default.',
  'credits.admin.bonus': 'Add credits for this month',
  'credits.admin.bonusAmount': 'Credits to add',
  'credits.admin.bonusReason': 'Reason (optional)',
  'credits.admin.bonusAdd': 'Add',
  'credits.admin.bonusAdding': 'Adding…',
  'credits.admin.bonusHint': 'Only counts this month. Use a negative number to take back credits you added.',
  'credits.admin.bonusIncluded': 'Includes {n} bonus credits this month.',
  'credits.admin.bonusAdded': 'Added {n} credits for this month.',
  'credits.admin.bonusRemoved': 'Took back {n} credits.',
  'credits.admin.updateFailed': 'Could not save credit settings.',
  'credits.admin.grantFailed': 'Could not add credits.',
};

const ar: Record<keyof typeof en, string> = {
  'chat.err.CREDITS_EXHAUSTED': 'لقد استهلكت جميع أرصدتك لهذا الشهر. يُعاد ضبطها في بداية الشهر القادم، أو اطلب المزيد من المسؤول.',

  'credits.label': 'الأرصدة',
  'credits.left': 'متبقٍ {left} من {total}',
  'credits.unlimited': 'أرصدة غير محدودة',
  'credits.meterLabel': 'الأرصدة المستخدمة هذا الشهر: {used} من {total}',
  'credits.warning': 'لقد استخدمت {pct}% من أرصدة هذا الشهر.',
  'credits.exhausted': 'نفدت الأرصدة حتى {date}.',
  'credits.resets': 'تُجدَّد في {date}',

  'credits.admin.col': 'الأرصدة',
  'credits.admin.cellUsed': '{used} / {total}',
  'credits.admin.cellUnlimited': 'غير محدودة',

  'credits.admin.section': 'الأرصدة الشهرية',
  'credits.admin.usage': 'هذا الشهر: استُخدم {used} من {total} رصيد ({pct}%). تُجدَّد في {date}.',
  'credits.admin.usageUnlimited': 'هذا الشهر: استُخدم {used} رصيد. لا يُحظر أبدًا.',
  'credits.admin.unlimited': 'أرصدة غير محدودة',
  'credits.admin.adminNote': 'لا يُحظر المسؤولون بسبب الأرصدة.',
  'credits.admin.monthly': 'الحصة الشهرية (أرصدة)',
  'credits.admin.monthlyDefault': 'الافتراضي: {n}',
  'credits.admin.monthlyHint': 'الرصيد الواحد = 1,000 رمز عبر جميع الوكلاء والمهام. اتركه فارغًا لاستخدام الافتراضي.',
  'credits.admin.bonus': 'إضافة أرصدة لهذا الشهر',
  'credits.admin.bonusAmount': 'الأرصدة المضافة',
  'credits.admin.bonusReason': 'السبب (اختياري)',
  'credits.admin.bonusAdd': 'إضافة',
  'credits.admin.bonusAdding': 'جارٍ الإضافة…',
  'credits.admin.bonusHint': 'تُحتسب لهذا الشهر فقط. استخدم رقمًا سالبًا لاسترجاع أرصدة أضفتها.',
  'credits.admin.bonusIncluded': 'يشمل {n} رصيد إضافي هذا الشهر.',
  'credits.admin.bonusAdded': 'أُضيف {n} رصيد لهذا الشهر.',
  'credits.admin.bonusRemoved': 'استُرجع {n} رصيد.',
  'credits.admin.updateFailed': 'تعذّر حفظ إعدادات الأرصدة.',
  'credits.admin.grantFailed': 'تعذّرت إضافة الأرصدة.',
};

const credits = { en, ar };
export default credits;
